import { AssetKeys } from '../../assets/asset-keys';

import BgSystem from '../../../../images/theme-images/dark/bg-system.png';
import BgSystemMobile from '../../../../images/theme-images/dark/bg-system-m.png';

import Img404 from '../../../../images/theme-images/dark/404.svg';
import ImgChatOver from '../../../../images/theme-images/dark/chat-over.svg';
import ImgMaintain from '../../../../images/theme-images/dark/maintain.svg';
import ImgLoading from '../../../../images/theme-images/shared/loading.svg';

import IconLogo from '../../../../images/theme-images/dark/logo.svg';
import IconLongLogo from '../../../../images/theme-images/dark/long-logo.svg';
import IconLogin from '../../../../images/theme-images/shared/ic-24-login.svg';
import IconLogout from '../../../../images/theme-images/dark/ic-18-logout.svg';
import IconChat from '../../../../images/theme-images/shared/ic-60-chat.svg';
import IconClock from '../../../../images/theme-images/shared/ic-60-clock.svg';
import IconEarphone from '../../../../images/theme-images/shared/ic-60-earphone.svg';
import IconExpandCircle from '../../../../images/theme-images/dark/ic-28-expand-circle.svg';
import IconLanguage from '../../../../images/theme-images/dark/ic-18-language.svg';

import contextFontSizeBtnIcon from '../../../../images/theme-images/dark/context-font-size-btn/icon-20-text@2x.webp';
import disabledContextFontSizeBtnIcon from '../../../../images/theme-images/dark/context-font-size-btn-disabled/icon-20-text@2x.webp';
import emojiPickerIcon from '../../../../images/theme-images/dark/emoji-picker/icon-20-emoji@2x.webp';
import disabledEmojiPickerIcon from '../../../../images/theme-images/dark/emoji-picker-disabled/icon-20-emoji@2x.webp';
import fileIcon from '../../../../images/theme-images/shared/file/icon-36-file@2x.webp';
import removeUploadFileBtnIcon from '../../../../images/theme-images/dark/remove-upload-file-btn/icon-20-close-fill@2x.webp';
import screenshotBtnIcon from '../../../../images/theme-images/dark/screenshot-btn/icon-20-screenshot@2x.webp';
import disabledScreenshotBtnIcon from '../../../../images/theme-images/dark/screenshot-btn-disabled/icon-20-screenshot@2x.webp';
import submitBtnIcon from '../../../../images/theme-images/dark/submit-btn/icon-20-send@2x.webp';
import disabledSubmitBtnIcon from '../../../../images/theme-images/dark/submit-btn-disabled/icon-20-send@2x.webp';
import cantSendSubmitBtnIcon from '../../../../images/theme-images/dark/submit-btn-cant-send/icon-20-send@2x.webp';
import uploadFileBtnIcon from '../../../../images/theme-images/dark/upload-file-btn/icon-20-attach-sharp@2x.webp';
import disabledUploadFileBtnIcon from '../../../../images/theme-images/dark/upload-file-btn-disabled/icon-20-attach-sharp@2x.webp';
import videoPlayBtnIcon from '../../../../images/theme-images/shared/video-play-btn/icon-24-play-fill@2x.webp';
import extendBtnIcon from '../../../../images/theme-images/dark/extend-btn/icon-20-arrow-right@2x.webp';

import IcFileSvg from '../../../../images/theme-images/dark/ic-40-file.svg';
import IcAlertSvg from '../../../../images/theme-images/dark/ic-alert/icon-24-alert@2x.webp';
import IcPlaySvg from '../../../../images/theme-images/dark/ic-32-play.svg';
import IcDownloadSvg from '../../../../images/theme-images/shared/ic-18-download.svg';
import IcPlayFillSvg from '../../../../images/theme-images/shared/ic-40-play-fill.svg';
import IcAnsweringSvg from '../../../../images/theme-images/dark/ic-answering/icon-64-answering@2x.webp';
import IcPurpleCopySvg from '../../../../images/theme-images/dark/ic-18-copy.svg';
import IcUploadSvg from '../../../../images/theme-images/shared/ic-16-upload.svg';
import IcArrowDownSvg from '../../../../images/theme-images/shared/ic-18-arrow-down.svg';
import IcArrowUpSvg from '../../../../images/theme-images/shared/ic-18-arrow-up.svg';
import IcArrowLeftSvg from '../../../../images/theme-images/dark/ic-24-arrow-left.svg';
import IcArrowRightSvg from '../../../../images/theme-images/dark/ic-24-arrow-right.svg';
import IcPurpleEditSvg from '../../../../images/theme-images/dark/ic-edit/icon-20-edit@2x.webp';
import IcBlackQuoteSvg from '../../../../images/theme-images/dark/ic-16-reply.svg';
import IcBlackCopySvg from '../../../../images/theme-images/dark/ic-16-copy.svg';
import IcImageSvg from '../../../../images/theme-images/dark/ic-24-image.svg';

// TODO const EMPTY = '';

// Rule: {Bg|Img|Icon}_{component|place}_{description...}
export const darkAssets = {
	[AssetKeys.BG_LOGIN]: BgSystem,
	[AssetKeys.BG_HOME]: BgSystem,
	[AssetKeys.BG_MAIN]: BgSystem,
	[AssetKeys.BG_CHAT]: BgSystem,
	[AssetKeys.BG_SYSTEM]: BgSystem,

	[AssetKeys.BG_LOGIN_MOBILE]: BgSystemMobile,
	[AssetKeys.BG_HOME_MOBILE]: BgSystemMobile,
	[AssetKeys.BG_MAIN_MOBILE]: BgSystemMobile,
	[AssetKeys.BG_CHAT_MOBILE]: BgSystemMobile,
	[AssetKeys.BG_SYSTEM_MOBILE]: BgSystemMobile,

	// Png or Svg 大圖：Img_xxx
	[AssetKeys.IMG_404]: Img404,
	[AssetKeys.IMG_CHAT_OVER]: ImgChatOver,
	[AssetKeys.IMG_MAINTAIN]: ImgMaintain,
	[AssetKeys.IMG_LOADING]: ImgLoading,

	// Component 內部使用的 icon or png 小圖：Icon_xxx
	[AssetKeys.ICON_LOGO]: IconLogo,
	[AssetKeys.ICON_LONG_LOGO]: IconLongLogo,
	[AssetKeys.ICON_LOGIN]: IconLogin,
	[AssetKeys.ICON_LOGOUT]: IconLogout,
	[AssetKeys.ICON_CLIENT_ENTRIES_NORMAL_REPLY]: IconChat,
	[AssetKeys.ICON_CLIENT_ENTRIES_QUICK_PATH]: IconClock,
	[AssetKeys.ICON_CLIENT_ENTRIES_SMART_REPLY]: IconEarphone,
	[AssetKeys.ICON_CLIENT_ENTRIES_ARTICLE_EXPAND]: IconExpandCircle,
	[AssetKeys.ICON_LANGUAGE]: IconLanguage,
	[AssetKeys.ICON_UPLOAD_FILE]: uploadFileBtnIcon,
	[AssetKeys.ICON_CONTEXT_FONT_SIZE_BTN]: contextFontSizeBtnIcon,
	[AssetKeys.ICON_DISABLED_CONTEXT_FONT_SIZE_BTN]: disabledContextFontSizeBtnIcon,
	[AssetKeys.ICON_EMOJI_PICKER]: emojiPickerIcon,
	[AssetKeys.ICON_DISABLED_EMOJI_PICKER]: disabledEmojiPickerIcon,
	[AssetKeys.ICON_FILE]: fileIcon,
	[AssetKeys.ICON_REMOVE_UPLOAD_FILE_BTN]: removeUploadFileBtnIcon,
	[AssetKeys.ICON_SCREENSHOT_BTN]: screenshotBtnIcon,
	[AssetKeys.ICON_DISABLED_SCREENSHOT_BTN]: disabledScreenshotBtnIcon,
	[AssetKeys.ICON_SUBMIT_BTN]: submitBtnIcon,
	[AssetKeys.ICON_DISABLED_SUBMIT_BTN]: disabledSubmitBtnIcon,
	[AssetKeys.ICON_CANT_SEND_SUBMIT_BTN]: cantSendSubmitBtnIcon,
	[AssetKeys.ICON_UPLOAD_FILE_BTN]: uploadFileBtnIcon,
	[AssetKeys.ICON_DISABLED_UPLOAD_FILE_BTN]: disabledUploadFileBtnIcon,
	[AssetKeys.ICON_VIDEO_PLAY_BTN]: videoPlayBtnIcon,
	[AssetKeys.ICON_EXTEND_BTN]: extendBtnIcon,

	[AssetKeys.ICON_DIALOG_FILE]: IcFileSvg,
	[AssetKeys.ICON_ALERT]: IcAlertSvg,
	[AssetKeys.ICON_PLAY]: IcPlaySvg,
	[AssetKeys.ICON_DOWNLOAD]: IcDownloadSvg,
	[AssetKeys.ICON_PLAY_FILL]: IcPlayFillSvg,
	[AssetKeys.ICON_ANSWERING]: IcAnsweringSvg,
	[AssetKeys.ICON_PURPLE_COPY]: IcPurpleCopySvg,
	[AssetKeys.ICON_UPLOAD]: IcUploadSvg,
	[AssetKeys.ICON_ARROW_DOWN]: IcArrowDownSvg,
	[AssetKeys.ICON_ARROW_UP]: IcArrowUpSvg,
	[AssetKeys.ICON_ARROW_LEFT]: IcArrowLeftSvg,
	[AssetKeys.ICON_ARROW_RIGHT]: IcArrowRightSvg,
	[AssetKeys.ICON_PURPLE_EDIT]: IcPurpleEditSvg,
	[AssetKeys.ICON_BLACK_QUOTE]: IcBlackQuoteSvg,
	[AssetKeys.ICON_BLACK_COPY]: IcBlackCopySvg,
	[AssetKeys.ICON_IMAGE]: IcImageSvg,
};
